import { render, staticRenderFns } from "./NotificacoesHosp.vue?vue&type=template&id=6e1aff91&scoped=true&"
import script from "./NotificacoesHosp.vue?vue&type=script&lang=js&"
export * from "./NotificacoesHosp.vue?vue&type=script&lang=js&"
import style0 from "./NotificacoesHosp.vue?vue&type=style&index=0&id=6e1aff91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1aff91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
